import { useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
  ],
};

const formats = [
  "header", "bold", "italic", "underline", "strike", "color",
  "background", "list", "bullet", "link",
];

export default function CommentEditor({ inputId, inputLabel, ...props }) {
  const editorRef = useRef(null);

  useEffect(() => {
    if (!inputId && !inputLabel) return;
    const editor = editorRef.current.getEditor().root;
    if (inputId) editor.id = inputId;
    if (inputLabel) editor.setAttribute("aria-label", inputLabel);
    editor.setAttribute("role", "textbox");
    editor.setAttribute("aria-multiline", "true");
  }, [inputId, inputLabel]);

  return (
    <>
      <ReactQuill ref={inputId || inputLabel ? editorRef : undefined} theme="snow" modules={modules} formats={formats} {...props} />
      <style>{`
  .comment-editor .ql-toolbar.ql-snow {
    border: 0;
    border-bottom: 1px solid #e5e7eb;
    background: #f8fafc;
    padding: 8px 10px;
  }

  .comment-editor .ql-container.ql-snow {
    border: 0;
  }

  .comment-editor .ql-editor {
    min-height: 56px;
    max-height: 220px;
    overflow-y: auto;
    font-size: 0.95rem;
    line-height: 1.5;
    padding: 10px 14px;
  }

  .comment-editor .ql-editor.ql-blank::before {
    left: 14px;
    right: 14px;
    font-style: normal;
    color: #9ca3af;
  }

  .comment-editor .ql-picker-label,
  .comment-editor .ql-stroke,
  .comment-editor .ql-fill {
    color: #475569;
    stroke: #475569;
  }

  .comment-editor .ql-toolbar button:hover,
  .comment-editor .ql-toolbar button:focus {
    color: #0f172a;
  }

  .comment-editor .ql-toolbar button:hover .ql-stroke,
  .comment-editor .ql-toolbar button:focus .ql-stroke {
    stroke: #0f172a;
  }
      `}</style>
    </>
  );
}
